module.exports = __webpack_public_path__ + "static/media/SF64.d288b4af.jpg";